export const RatePlanStatusEnum = Object.freeze({
    DRAFT: 'DRAFT',
    ACTIVE: 'ACTIVE',
    DEPRECATED: 'DEPRECATED'
});

export default RatePlanStatusEnum;
